'use client';

import { useCallback, useState } from 'react';

export type UseOpenProps = {
  open: () => void;
  close: () => void;
  opened: boolean;
};

export interface UseOpen {
  (defaultOpen?: boolean): UseOpenProps;
}

export const useOpen: UseOpen = (defaultOpen) => {
  const [opened, setOpened] = useState(defaultOpen ?? false);

  const open = useCallback(() => {
    setOpened(true);
  }, [setOpened]);

  const close = useCallback(() => {
    setOpened(false);
  }, [setOpened]);

  return {
    open,
    close,
    opened,
  };
};
